import { Navigate } from 'react-router-dom';
import UrlEnums from '@/components/connections/enums/UrlEnums';

const Home = () => <Navigate to={UrlEnums.COMPANIES} replace />;

export default Home;
